export default "/images/304715620bc78778c2b962e03b212b8b.avif";